import React from 'react';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import SectionHeader from '../common/components/SectionHeader';
import { hasPermission } from '@apply/ui';
import { PermissionType } from '@apply/constants';

function UsersLandingPage() {
    const styles = {
        linkPaper: {
            color: '#2C5591',
            textAlign: 'center' as const,
            padding: 50,
            fontSize: 14,
            margin: 20,
            width: 300,
        },
        flexContainer: {
            display: 'flex',
            flexDirection: 'row' as const,
            justifyContent: 'space-evenly' as const,
            overflow: 'auto',
        },
        verticalPadding: {
            paddingTop: 50,
            paddingBottom: 50,
        },
    };

    return (
        <>
            <SectionHeader title='User Accounts' />
            <div
                className='row scrollable-content'
                style={styles.flexContainer}
            >
                {hasPermission(PermissionType.AdminUserView) && (
                    <Link
                        to='/users/admins'
                        style={styles.verticalPadding}
                    >
                        <Paper
                            style={styles.linkPaper}
                            elevation={3}
                        >
                            <h1>Admin Users</h1>
                            <p>Manage Admin Users</p>
                        </Paper>
                    </Link>
                )}

                <Link
                    to='/users/principals'
                    style={styles.verticalPadding}
                >
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <h1>Principals</h1>
                        <p>Manage Principal Users</p>
                    </Paper>
                </Link>
                <Link
                    to='/users/generalcontractors'
                    style={styles.verticalPadding}
                >
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <h1>Contractors</h1>
                        <p>Manage Contractors</p>
                    </Paper>
                </Link>
                <Link
                    to='/users/brokers'
                    style={styles.verticalPadding}
                >
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <h1>Brokers</h1>
                        <p>Manage Broker Users</p>
                    </Paper>
                </Link>
                <Link
                    to='/users/reviewers'
                    style={styles.verticalPadding}
                >
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <h1>Reviewers</h1>
                        <p>Manage Reviewers</p>
                    </Paper>
                </Link>
                <div className='columns small-12 large-12'>
                    <h2 className='decorated'> </h2>
                </div>
            </div>
        </>
    );
}

export default UsersLandingPage;
